
// /* ── 1. Set date immediately ── */
// (function(){
//   var d=new Date(),p=function(n){return('0'+n).slice(-2)};
//   var el=document.getElementById('tfDate');
//   if(el) el.value=p(d.getDate())+'/'+p(d.getMonth()+1)+'/'+d.getFullYear();
// })();

// /* ── 2. Country data ── */
// var TF_C=[
//   {n:"Afghanistan",c:"AF",d:"+93"},{n:"Albania",c:"AL",d:"+355"},
//   {n:"Algeria",c:"DZ",d:"+213"},{n:"Andorra",c:"AD",d:"+376"},
//   {n:"Angola",c:"AO",d:"+244"},{n:"Antigua and Barbuda",c:"AG",d:"+1-268"},
//   {n:"Argentina",c:"AR",d:"+54"},{n:"Armenia",c:"AM",d:"+374"},
//   {n:"Australia",c:"AU",d:"+61"},{n:"Austria",c:"AT",d:"+43"},
//   {n:"Azerbaijan",c:"AZ",d:"+994"},{n:"Bahamas",c:"BS",d:"+1-242"},
//   {n:"Bahrain",c:"BH",d:"+973"},{n:"Bangladesh",c:"BD",d:"+880"},
//   {n:"Barbados",c:"BB",d:"+1-246"},{n:"Belarus",c:"BY",d:"+375"},
//   {n:"Belgium",c:"BE",d:"+32"},{n:"Belize",c:"BZ",d:"+501"},
//   {n:"Benin",c:"BJ",d:"+229"},{n:"Bhutan",c:"BT",d:"+975"},
//   {n:"Bolivia",c:"BO",d:"+591"},{n:"Bosnia and Herzegovina",c:"BA",d:"+387"},
//   {n:"Botswana",c:"BW",d:"+267"},{n:"Brazil",c:"BR",d:"+55"},
//   {n:"Brunei",c:"BN",d:"+673"},{n:"Bulgaria",c:"BG",d:"+359"},
//   {n:"Burkina Faso",c:"BF",d:"+226"},{n:"Burundi",c:"BI",d:"+257"},
//   {n:"Cabo Verde",c:"CV",d:"+238"},{n:"Cambodia",c:"KH",d:"+855"},
//   {n:"Cameroon",c:"CM",d:"+237"},{n:"Canada",c:"CA",d:"+1"},
//   {n:"Central African Republic",c:"CF",d:"+236"},{n:"Chad",c:"TD",d:"+235"},
//   {n:"Chile",c:"CL",d:"+56"},{n:"China",c:"CN",d:"+86"},
//   {n:"Colombia",c:"CO",d:"+57"},{n:"Comoros",c:"KM",d:"+269"},
//   {n:"Congo (Brazzaville)",c:"CG",d:"+242"},{n:"Costa Rica",c:"CR",d:"+506"},
//   {n:"Croatia",c:"HR",d:"+385"},{n:"Cuba",c:"CU",d:"+53"},
//   {n:"Cyprus",c:"CY",d:"+357"},{n:"Czech Republic",c:"CZ",d:"+420"},
//   {n:"Dem. Rep. Congo",c:"CD",d:"+243"},{n:"Denmark",c:"DK",d:"+45"},
//   {n:"Djibouti",c:"DJ",d:"+253"},{n:"Dominica",c:"DM",d:"+1-767"},
//   {n:"Dominican Republic",c:"DO",d:"+1-809"},{n:"Ecuador",c:"EC",d:"+593"},
//   {n:"Egypt",c:"EG",d:"+20"},{n:"El Salvador",c:"SV",d:"+503"},
//   {n:"Equatorial Guinea",c:"GQ",d:"+240"},{n:"Eritrea",c:"ER",d:"+291"},
//   {n:"Estonia",c:"EE",d:"+372"},{n:"Eswatini",c:"SZ",d:"+268"},
//   {n:"Ethiopia",c:"ET",d:"+251"},{n:"Fiji",c:"FJ",d:"+679"},
//   {n:"Finland",c:"FI",d:"+358"},{n:"France",c:"FR",d:"+33"},
//   {n:"Gabon",c:"GA",d:"+241"},{n:"Gambia",c:"GM",d:"+220"},
//   {n:"Georgia",c:"GE",d:"+995"},{n:"Germany",c:"DE",d:"+49"},
//   {n:"Ghana",c:"GH",d:"+233"},{n:"Greece",c:"GR",d:"+30"},
//   {n:"Grenada",c:"GD",d:"+1-473"},{n:"Guatemala",c:"GT",d:"+502"},
//   {n:"Guinea",c:"GN",d:"+224"},{n:"Guinea-Bissau",c:"GW",d:"+245"},
//   {n:"Guyana",c:"GY",d:"+592"},{n:"Haiti",c:"HT",d:"+509"},
//   {n:"Honduras",c:"HN",d:"+504"},{n:"Hungary",c:"HU",d:"+36"},
//   {n:"Iceland",c:"IS",d:"+354"},{n:"India",c:"IN",d:"+91"},
//   {n:"Indonesia",c:"ID",d:"+62"},{n:"Iran",c:"IR",d:"+98"},
//   {n:"Iraq",c:"IQ",d:"+964"},{n:"Ireland",c:"IE",d:"+353"},
//   {n:"Italy",c:"IT",d:"+39"},{n:"Jamaica",c:"JM",d:"+1-876"},
//   {n:"Japan",c:"JP",d:"+81"},{n:"Jordan",c:"JO",d:"+962"},
//   {n:"Kazakhstan",c:"KZ",d:"+7"},{n:"Kenya",c:"KE",d:"+254"},
//   {n:"Kiribati",c:"KI",d:"+686"},{n:"Kuwait",c:"KW",d:"+965"},
//   {n:"Kyrgyzstan",c:"KG",d:"+996"},{n:"Laos",c:"LA",d:"+856"},
//   {n:"Latvia",c:"LV",d:"+371"},{n:"Lebanon",c:"LB",d:"+961"},
//   {n:"Lesotho",c:"LS",d:"+266"},{n:"Liberia",c:"LR",d:"+231"},
//   {n:"Libya",c:"LY",d:"+218"},{n:"Liechtenstein",c:"LI",d:"+423"},
//   {n:"Lithuania",c:"LT",d:"+370"},{n:"Luxembourg",c:"LU",d:"+352"},
//   {n:"Madagascar",c:"MG",d:"+261"},{n:"Malawi",c:"MW",d:"+265"},
//   {n:"Malaysia",c:"MY",d:"+60"},{n:"Maldives",c:"MV",d:"+960"},
//   {n:"Mali",c:"ML",d:"+223"},{n:"Malta",c:"MT",d:"+356"},
//   {n:"Marshall Islands",c:"MH",d:"+692"},{n:"Mauritania",c:"MR",d:"+222"},
//   {n:"Mauritius",c:"MU",d:"+230"},{n:"Mexico",c:"MX",d:"+52"},
//   {n:"Micronesia",c:"FM",d:"+691"},{n:"Moldova",c:"MD",d:"+373"},
//   {n:"Monaco",c:"MC",d:"+377"},{n:"Mongolia",c:"MN",d:"+976"},
//   {n:"Montenegro",c:"ME",d:"+382"},{n:"Morocco",c:"MA",d:"+212"},
//   {n:"Mozambique",c:"MZ",d:"+258"},{n:"Myanmar",c:"MM",d:"+95"},
//   {n:"Namibia",c:"NA",d:"+264"},{n:"Nauru",c:"NR",d:"+674"},
//   {n:"Nepal",c:"NP",d:"+977"},{n:"Netherlands",c:"NL",d:"+31"},
//   {n:"New Zealand",c:"NZ",d:"+64"},{n:"Nicaragua",c:"NI",d:"+505"},
//   {n:"Niger",c:"NE",d:"+227"},{n:"Nigeria",c:"NG",d:"+234"},
//   {n:"North Korea",c:"KP",d:"+850"},{n:"North Macedonia",c:"MK",d:"+389"},
//   {n:"Norway",c:"NO",d:"+47"},{n:"Oman",c:"OM",d:"+968"},
//   {n:"Pakistan",c:"PK",d:"+92"},{n:"Palau",c:"PW",d:"+680"},
//   {n:"Panama",c:"PA",d:"+507"},{n:"Papua New Guinea",c:"PG",d:"+675"},
//   {n:"Paraguay",c:"PY",d:"+595"},{n:"Peru",c:"PE",d:"+51"},
//   {n:"Philippines",c:"PH",d:"+63"},{n:"Poland",c:"PL",d:"+48"},
//   {n:"Portugal",c:"PT",d:"+351"},{n:"Qatar",c:"QA",d:"+974"},
//   {n:"Romania",c:"RO",d:"+40"},{n:"Russia",c:"RU",d:"+7"},
//   {n:"Rwanda",c:"RW",d:"+250"},{n:"Saint Kitts and Nevis",c:"KN",d:"+1-869"},
//   {n:"Saint Lucia",c:"LC",d:"+1-758"},{n:"Saint Vincent",c:"VC",d:"+1-784"},
//   {n:"Samoa",c:"WS",d:"+685"},{n:"San Marino",c:"SM",d:"+378"},
//   {n:"Saudi Arabia",c:"SA",d:"+966"},{n:"Senegal",c:"SN",d:"+221"},
//   {n:"Serbia",c:"RS",d:"+381"},{n:"Seychelles",c:"SC",d:"+248"},
//   {n:"Sierra Leone",c:"SL",d:"+232"},{n:"Singapore",c:"SG",d:"+65"},
//   {n:"Slovakia",c:"SK",d:"+421"},{n:"Slovenia",c:"SI",d:"+386"},
//   {n:"Solomon Islands",c:"SB",d:"+677"},{n:"Somalia",c:"SO",d:"+252"},
//   {n:"South Africa",c:"ZA",d:"+27"},{n:"South Korea",c:"KR",d:"+82"},
//   {n:"South Sudan",c:"SS",d:"+211"},{n:"Spain",c:"ES",d:"+34"},
//   {n:"Sri Lanka",c:"LK",d:"+94"},{n:"Sudan",c:"SD",d:"+249"},
//   {n:"Suriname",c:"SR",d:"+597"},{n:"Sweden",c:"SE",d:"+46"},
//   {n:"Switzerland",c:"CH",d:"+41"},{n:"Syria",c:"SY",d:"+963"},
//   {n:"Taiwan",c:"TW",d:"+886"},{n:"Tajikistan",c:"TJ",d:"+992"},
//   {n:"Tanzania",c:"TZ",d:"+255"},{n:"Thailand",c:"TH",d:"+66"},
//   {n:"Timor-Leste",c:"TL",d:"+670"},{n:"Togo",c:"TG",d:"+228"},
//   {n:"Tonga",c:"TO",d:"+676"},{n:"Trinidad and Tobago",c:"TT",d:"+1-868"},
//   {n:"Tunisia",c:"TN",d:"+216"},{n:"Turkey",c:"TR",d:"+90"},
//   {n:"Turkmenistan",c:"TM",d:"+993"},{n:"Tuvalu",c:"TV",d:"+688"},
//   {n:"Uganda",c:"UG",d:"+256"},{n:"Ukraine",c:"UA",d:"+380"},
//   {n:"United Arab Emirates",c:"AE",d:"+971"},{n:"United Kingdom",c:"GB",d:"+44"},
//   {n:"United States",c:"US",d:"+1"},{n:"Uruguay",c:"UY",d:"+598"},
//   {n:"Uzbekistan",c:"UZ",d:"+998"},{n:"Vanuatu",c:"VU",d:"+678"},
//   {n:"Vatican City",c:"VA",d:"+379"},{n:"Venezuela",c:"VE",d:"+58"},
//   {n:"Vietnam",c:"VN",d:"+84"},{n:"Yemen",c:"YE",d:"+967"},
//   {n:"Zambia",c:"ZM",d:"+260"},{n:"Zimbabwe",c:"ZW",d:"+263"}
// ];

// /* ── 3. Phone length map ── */
// var TF_PL={
//   "+1":10,"+44":10,"+93":9,"+355":9,"+213":9,"+376":8,"+244":9,"+54":10,
//   "+374":8,"+61":9,"+43":10,"+994":9,"+973":8,"+880":10,"+375":9,"+32":9,
//   "+501":8,"+229":8,"+975":8,"+591":8,"+387":8,"+267":8,"+55":11,"+673":7,
//   "+359":9,"+226":8,"+257":8,"+238":7,"+855":9,"+237":9,"+506":8,"+385":9,
//   "+53":8,"+357":8,"+420":9,"+243":9,"+45":8,"+253":7,"+593":9,"+20":10,
//   "+503":8,"+240":7,"+291":7,"+372":8,"+251":9,"+679":7,"+358":9,"+33":9,
//   "+241":8,"+220":7,"+995":9,"+49":11,"+233":10,"+30":10,"+502":8,"+224":8,
//   "+245":7,"+592":7,"+509":8,"+504":8,"+36":9,"+354":7,"+91":10,"+62":11,
//   "+98":10,"+964":10,"+353":9,"+39":10,"+81":10,"+962":9,"+7":10,"+254":10,
//   "+686":5,"+965":8,"+996":9,"+856":9,"+371":8,"+961":8,"+266":8,"+231":8,
//   "+218":9,"+423":7,"+370":8,"+352":9,"+261":9,"+265":9,"+60":10,"+960":7,
//   "+223":8,"+356":8,"+692":5,"+222":7,"+230":7,"+52":10,"+691":5,"+373":8,
//   "+377":8,"+976":8,"+382":8,"+212":9,"+258":9,"+95":9,"+264":9,"+674":5,
//   "+977":10,"+31":9,"+64":9,"+505":8,"+227":8,"+234":10,"+850":9,"+389":8,
//   "+47":8,"+968":8,"+92":10,"+680":5,"+507":8,"+675":7,"+595":9,"+51":9,
//   "+63":10,"+48":9,"+351":9,"+974":8,"+40":9,"+250":9,"+966":9,"+221":9,
//   "+381":9,"+248":7,"+232":8,"+65":8,"+421":9,"+386":9,"+677":5,"+252":8,
//   "+27":9,"+82":10,"+211":9,"+34":9,"+94":10,"+249":9,"+597":7,"+46":9,
//   "+41":9,"+963":9,"+886":9,"+992":9,"+255":10,"+66":9,"+670":5,"+228":8,
//   "+676":5,"+216":8,"+90":10,"+993":8,"+688":5,"+256":9,"+380":9,"+971":8,
//   "+598":8,"+998":9,"+678":5,"+379":8,"+58":10,"+84":9,"+967":9,"+260":9,"+263":9
// };

// /* ── 4. Validation helpers ── */
// var _tfOrigPlaceholders = new WeakMap();

// function fieldError(input, message) {
//   if (!input) return;
//   if (!_tfOrigPlaceholders.has(input)) {
//     _tfOrigPlaceholders.set(input, input.placeholder || '');
//   }
//   input.placeholder = '⚠ ' + message;
//   input.value = '';
//   input.classList.add('tf-input-error');
//   var wrap = input.closest('div') || input.parentElement;
//   if (wrap) {
//     wrap.classList.remove('tf-field-error');
//     void wrap.offsetWidth;
//     wrap.classList.add('tf-field-error');
//   }
//   function onInput() {
//     fieldClear(input);
//     input.removeEventListener('input', onInput);
//     input.removeEventListener('change', onInput);
//   }
//   input.addEventListener('input', onInput);
//   input.addEventListener('change', onInput);
// }

// function fieldClear(input) {
//   if (!input) return;
//   input.classList.remove('tf-input-error');
//   if (_tfOrigPlaceholders.has(input)) {
//     input.placeholder = _tfOrigPlaceholders.get(input);
//   }
//   var wrap = input.closest('div') || input.parentElement;
//   if (wrap) {
//     wrap.classList.remove('tf-field-error');
//     wrap.classList.add('tf-field-clearing');
//     setTimeout(function(){ wrap.classList.remove('tf-field-clearing'); }, 400);
//   }
// }

// function scrollToFirst() {
//   setTimeout(function(){
//     var first = document.querySelector('.tf-field-error input, .tf-input-error');
//     if (first) {
//       first.scrollIntoView({ behavior: 'smooth', block: 'center' });
//       first.focus({ preventScroll: true });
//     }
//   }, 60);
// }

// /* ════════════════════════════════════════════
//    ── DRAFT PERSISTENCE (localStorage) ──
//    Saves every field on input/change.
//    Restores on page load. Cleared on success.
//    ════════════════════════════════════════════ */
// var TF_DRAFT_KEY = 'tf_draft_v1';

// function tfSaveDraft() {
//   try {
//     var form = document.getElementById('tfForm');
//     if (!form) return;
//     var draft = {};
//     form.querySelectorAll(
//       'input:not([type=file]):not([type=submit]):not([type=button]), textarea'
//     ).forEach(function(el) {
//       var key = el.name || el.id;
//       if (!key) return;
//       if (el.type === 'checkbox') {
//         draft[key] = el.checked;
//       } else if (el.type === 'radio') {
//         if (el.checked) draft[key] = el.value;
//       } else {
//         draft[key] = el.value;
//       }
//     });
//     localStorage.setItem(TF_DRAFT_KEY, JSON.stringify(draft));
//   } catch(e) {}
// }

// function tfRestoreDraft() {
//   try {
//     var raw = localStorage.getItem(TF_DRAFT_KEY);
//     if (!raw) return;
//     var draft = JSON.parse(raw);
//     var form = document.getElementById('tfForm');
//     if (!form) return;

//     form.querySelectorAll(
//       'input:not([type=file]):not([type=submit]):not([type=button]), textarea'
//     ).forEach(function(el) {
//       var key = el.name || el.id;
//       if (!key || !(key in draft)) return;
//       if (el.id === 'tfDate') return; /* always regenerated fresh */
//       if (el.type === 'checkbox') {
//         el.checked = !!draft[key];
//       } else if (el.type === 'radio') {
//         if (el.value === draft[key]) el.checked = true;
//       } else {
//         el.value = draft[key];
//       }
//     });

//     /* Re-sync country hidden field */
//     var cntryHidden = document.getElementById('tfCntryHidden');
//     if (cntryHidden && draft['country']) {
//       cntryHidden.value = draft['country'];
//     }

//   } catch(e) {}
// }

// function tfClearDraft() {
//   try { localStorage.removeItem(TF_DRAFT_KEY); } catch(e) {}
// }

// /* ── 5. Defer all interactive JS ── */
// (window.requestIdleCallback||function(cb){setTimeout(cb,100)})(function(){

// var tfEmailOk=false,tfSubmitting=false,tfCooldown=false,tfTimer=null;
// var tfDeclAccepted=false;
// var SEND_OTP='https://hook.us2.make.com/oy8cimjhhfeh4rhifgsx2h7uhk39z3ej';
// var VERIFY_OTP='https://hook.us2.make.com/jyx8okv6i6sf8sf2furos1gyld7ycu8a';

// function $i(id){return document.getElementById(id)}
// var tfForm=$i('tfForm'),tfEmail=$i('tfEmail'),tfSendOtp=$i('tfSendOtp'),
//     tfVerOtp=$i('tfVerifyOtp'),tfOtpBox=$i('tfOtpBox'),tfOtpIn=$i('tfOtpInput'),
//     tfStat=$i('tfOtpStatus'),tfCcIn=$i('tfCcInput'),tfCcLst=$i('tfCcList'),
//     tfPhIn=$i('tfPhone'),
//     tfCIn=$i('tfCntryInput'),tfCHid=$i('tfCntryHidden'),
//     tfCLst=$i('tfCntryList'),tfCTip=$i('tfCntryTip'),
//     tfLoad=$i('tfLoadPop'),tfSucc=$i('tfSuccPop'),
//     tfDeclChk=$i('tfDeclChk'),
//     tfDeclHidden=$i('tfDeclHidden');

// /* ── Restore saved draft ── */
// tfRestoreDraft();

// /* Re-sync declarations flag if checkbox was restored as checked */
// if (tfDeclChk && tfDeclChk.checked) {
//   tfDeclAccepted = true;
//   if (tfDeclHidden) tfDeclHidden.value = 'I accept all declarations and compliance terms';
// }

// /* ── Sync default country into hidden field ── */
// if (tfCIn && tfCHid && !tfCHid.value && tfCIn.value) {
//   tfCHid.value = tfCIn.value.trim();
// }

// /* ── Auto-save on any input/change ── */
// tfForm.addEventListener('input', tfSaveDraft, {passive: true});
// tfForm.addEventListener('change', tfSaveDraft, {passive: true});

// function show(el){el&&el.classList.remove('tf-hidden')}
// function hide(el){el&&el.classList.add('tf-hidden')}
// function stat(m){if(tfStat)tfStat.textContent=m}

// /* ── Toast ── */
// var tfToastEl=$i('tfToast'),tfToastTimer=null;
// function toast(msg,type){
//   if(!tfToastEl)return;
//   tfToastEl.textContent=msg;
//   tfToastEl.className=(type==='error'?'tf-toast--error':type==='warn'?'tf-toast--warn':'');
//   tfToastEl.classList.add('show');
//   clearTimeout(tfToastTimer);
//   tfToastTimer=setTimeout(function(){tfToastEl.classList.remove('show')},4000);
// }

// function validCc(v){
//   var t=v.trim();
//   return TF_C.some(function(c){return c.d===t});
// }
// function phLen(cc,num){
//   var r=TF_PL[cc.trim()];
//   return r?num.replace(/\D/g,'').length===r:false;
// }
// function reqLen(cc){return TF_PL[cc.trim()]||'?'}

// function renderList(ul,items,q,dial,onSel){
//   var lq=q.toLowerCase();
//   var filtered=items.filter(function(it){
//     return it.n.toLowerCase().includes(lq)||(dial&&it.d.includes(lq));
//   }).slice(0,60);
//   var frag=document.createDocumentFragment();
//   filtered.forEach(function(it,i){
//     var li=document.createElement('li');
//     li.setAttribute('role','option');
//     li.innerHTML='<img src="https://flagcdn.com/24x18/'+it.c.toLowerCase()+'.png" width="24" height="18" loading="lazy" alt="'+it.n+'" onerror="this.style.display=\'none\'">'
//       +'<span>'+(dial?it.d+' ('+it.n+')':it.n)+'</span>';
//     li._d=it;
//     if(i===0)li.classList.add('tf-sel');
//     li.addEventListener('click',function(){onSel(it)});
//     frag.appendChild(li);
//   });
//   ul.innerHTML='';ul.appendChild(frag);
//   ul.style.display=filtered.length?'block':'none';
// }

// function navList(ul,e){
//   var items=ul.querySelectorAll('li');if(!items.length)return;
//   var cur=Array.from(items).findIndex(function(li){return li.classList.contains('tf-sel')});
//   function mv(next){
//     if(cur>=0)items[cur].classList.remove('tf-sel');
//     items[next].classList.add('tf-sel');
//     items[next].scrollIntoView({block:'nearest'});
//   }
//   if(e.key==='ArrowDown'){e.preventDefault();mv((cur+1)%items.length)}
//   else if(e.key==='ArrowUp'){e.preventDefault();mv((cur-1+items.length)%items.length)}
//   else if(e.key==='Enter'){e.preventDefault();var s=ul.querySelector('li.tf-sel');if(s)s.click()}
//   else if(e.key==='Escape')ul.style.display='none';
// }

// /* ── Country autocomplete ── */
// var tfCFocusLock=false;
// function selCntry(it){
//   tfCIn.value=it.n;
//   tfCHid.value=it.n;
//   tfCLst.style.display='none';
//   tfCTip.classList.remove('show');
//   tfCIn.style.borderColor='#16a34a';
//   setTimeout(function(){tfCIn.style.borderColor=''},1000);
//   fieldClear(tfCIn);
//   tfCFocusLock=true;tfCIn.focus();setTimeout(function(){tfCFocusLock=false},100);
// }
// tfCIn.addEventListener('focus',function(){
//   if(tfCFocusLock){tfCFocusLock=false;return}
//   renderList(tfCLst,TF_C,tfCIn.value,false,selCntry);
//   tfCTip.classList.add('show');
// });
// tfCIn.addEventListener('input',function(){
//   tfCHid.value = this.value.trim();
//   renderList(tfCLst,TF_C,this.value,false,selCntry);
// });
// tfCIn.addEventListener('keydown',function(e){navList(tfCLst,e)});

// /* ── Phone CC ── */
// var tfPhFocusLock=false;
// function selCc(it){
//   tfCcIn.value=it.d;
//   tfCcLst.style.display='none';
//   fieldClear(tfCcIn);
//   tfPhFocusLock=true;tfPhIn.focus();setTimeout(function(){tfPhFocusLock=false},100);
// }
// tfCcIn.addEventListener('focus',function(){
//   if(tfPhFocusLock||tfCcIn.readOnly){tfPhFocusLock=false;return}
//   renderList(tfCcLst,TF_C,tfCcIn.value,true,selCc);
// });
// tfCcIn.addEventListener('input',function(){
//   if(tfCcIn.readOnly)return;
//   renderList(tfCcLst,TF_C,this.value,true,selCc);
// });
// tfCcIn.addEventListener('keydown',function(e){if(!tfCcIn.readOnly)navList(tfCcLst,e)});
// tfPhIn.addEventListener('input',function(){
//   var cc=tfCcIn.value.trim();
//   if(cc&&phLen(cc,this.value)) fieldClear(tfPhIn);
// },{passive:true});

// /* ── Close dropdowns on outside click ── */
// document.addEventListener('click',function(e){
//   if(!e.target.closest('#tfCcWrap'))tfCcLst.style.display='none';
//   if(!e.target.closest('#tfCntryWrap')){
//     tfCLst.style.display='none';
//     tfCTip.classList.remove('show');
//   }
// },{passive:true});

// /* ── OTP cooldown — 3 minutes ── */
// function startCooldown(){
//   tfCooldown=true;var t=300;
//   tfSendOtp.disabled=true;tfSendOtp.style.background='#9ca3af';
//   tfTimer=setInterval(function(){
//     if(--t<=0){
//       clearInterval(tfTimer);tfCooldown=false;
//       tfSendOtp.disabled=false;tfSendOtp.style.background='#1f7ca1';
//       tfSendOtp.textContent='Resend OTP';
//     } else {
//       var mins=Math.floor(t/60);
//       var secs=t%60;
//       tfSendOtp.textContent='Resend OTP ('+mins+':'+(secs<10?'0':'')+secs+')';
//     }
//   },1000);
// }

// /* ── Send OTP ── */
// tfSendOtp.addEventListener('click',async function(){
//   var em=tfEmail.value.trim();
//   var cc=tfCcIn.value.trim();
//   var ph=tfPhIn.value.trim();
//   var hasErr=false;

//   if(!em||!em.includes('@')){
//     fieldError(tfEmail,'Enter a valid email address');
//     hasErr=true;
//   }
//   if(!cc){
//     fieldError(tfCcIn,'Enter a country code e.g. +1');
//     hasErr=true;
//   } else if(!validCc(cc)){
//     fieldError(tfCcIn,'Enter a valid country code e.g. +1');
//     hasErr=true;
//   }
//   if(!ph){
//     fieldError(tfPhIn,'Enter phone number');
//     hasErr=true;
//   } else if(cc&&validCc(cc)&&!phLen(cc,ph)){
//     fieldError(tfPhIn,'Must be exactly '+reqLen(cc)+' digits');
//     hasErr=true;
//   }
//   if(hasErr){scrollToFirst();return;}

//   var otp=Math.floor(100000+Math.random()*900000);
//   window._tfOtp=otp;stat('Sending OTP…');tfSendOtp.disabled=true;
//   try{
//     await fetch(SEND_OTP+'?email='+encodeURIComponent(em)+'&otp='+otp);
//     show(tfOtpBox);show(tfVerOtp);stat('OTP sent to your email');
//     tfSendOtp.textContent='Resend OTP';startCooldown();
//   }catch(e){
//     stat('Failed to send OTP. Please try again.');
//     tfSendOtp.disabled=false;tfSendOtp.style.background='#1f7ca1';
//   }
// });

// /* ── Verify OTP ── */
// tfVerOtp.addEventListener('click',async function(){
//   var u=tfOtpIn.value.trim();
//   if(!u){fieldError(tfOtpIn,'Enter the 6-digit OTP');scrollToFirst();return;}
//   stat('Verifying…');tfVerOtp.disabled=true;
//   try{
//     var res=await fetch(VERIFY_OTP+'?email='+encodeURIComponent(tfEmail.value.trim())+'&otp='+u);
//     var data=await res.json();
//     if(data.status==='verified'){
//       tfEmailOk=true;stat('✓ Email and phone verified');
//       [tfEmail,tfCcIn,tfPhIn].forEach(function(el){
//         el.readOnly=true;el.style.background='#f3f4f6';
//       });
//       tfCcIn.style.cursor='not-allowed';tfCcLst.style.display='none';
//       hide(tfSendOtp);hide(tfOtpBox);hide(tfVerOtp);
//     } else {
//       fieldError(tfOtpIn,'Invalid OTP — try again');
//       scrollToFirst();
//     }
//   }catch(e){stat('Verification failed. Please try again.')}
//   finally{tfVerOtp.disabled=false}
// });

// /* ── Declarations checkbox ── */
// if(tfDeclChk){
//   tfDeclChk.addEventListener('change',function(){
//     tfDeclAccepted=this.checked;
//     tfDeclHidden.value=this.checked?'I accept all declarations and compliance terms':'';
//   });
// }

// /* ── Document management ── */
// var tfDocN=1;var TF_MAX=4;
// window.tfAddDoc=function(){
//   if(tfDocN>=TF_MAX)return;
//   tfDocN++;
//   var wrap=$i('tfDocFields'),div=document.createElement('div');
//   div.className='tf__doc-row';div.dataset.index=tfDocN;
//   div.innerHTML='<input type="file" name="document'+tfDocN+'" accept=".pdf,.jpg,.png">'
//     +'<button type="button" class="tf__doc-btn tf__doc-btn--rem" onclick="tfRemDoc(this)">−</button>';
//   wrap.appendChild(div);
//   var ab=$i('tfAddDocBtn');if(ab)ab.disabled=(tfDocN>=TF_MAX);
// };
// window.tfRemDoc=function(btn){
//   var f=btn.closest('.tf__doc-row');
//   if(f){f.remove();tfDocN--;var ab=$i('tfAddDocBtn');if(ab)ab.disabled=(tfDocN>=TF_MAX);}
// };

// /* ════════════════════════════════════════════
//    ── FORM SUBMIT ──
//    ════════════════════════════════════════════ */
// tfForm.addEventListener('submit',async function(e){
//   e.preventDefault();
//   if(tfSubmitting)return;

//   var firstErr=null;
//   function markErr(input,msg){
//     fieldError(input,msg);
//     if(!firstErr)firstErr=input;
//   }

//   /* 1. Declarations */
//   if(!tfDeclAccepted){
//     var declWrap=tfDeclChk?tfDeclChk.closest('.tf__fs'):null;
//     if(declWrap){
//       declWrap.style.border='2px solid #ef4444';
//       declWrap.style.animation='none';
//       void declWrap.offsetWidth;
//       declWrap.style.animation='tf-shake .45s ease both';
//       tfDeclChk.addEventListener('change',function(){
//         declWrap.style.border='';declWrap.style.animation='';
//       },{once:true});
//     }
//     if(!firstErr)firstErr=tfDeclChk;
//     toast('Please accept the Declarations & Compliance to proceed.','error');
//   }

//   /* 2. Email + OTP verification */
//   if(!tfEmailOk){
//     markErr(tfEmail,'Verify your email first — click Send OTP');
//   }

//   /* 3. Country */
//   var countryVal=(tfCHid.value||'').trim()||(tfCIn.value||'').trim();
//   if(!countryVal){
//     markErr(tfCIn,'Enter your country of registration');
//   } else {
//     tfCHid.value=countryVal;
//     tfCIn.value=countryVal;
//   }

//   /* 4. Required text/number inputs */
//   var reqInputs=tfForm.querySelectorAll(
//     'input[required]:not([type=radio]):not([type=checkbox]):not([type=file]):not(#tfEmail):not(#tfPhone):not(#tfCntryHidden):not(#tfCntryInput):not(#tfCcInput)'
//   );
//   reqInputs.forEach(function(inp){
//     if(!inp.value.trim()){
//       var fs=inp.closest('fieldset')||inp.parentElement;
//       var labelEl=fs?fs.querySelector('label'):null;
//       var name=labelEl?labelEl.textContent.replace('*','').trim():'This field';
//       markErr(inp,name+' is required');
//     }
//   });

//   /* 5. Phone CC + length */
//   var phCc=tfCcIn.value.trim();
//   if(!phCc){
//     markErr(tfCcIn,'Enter a country code e.g. +1');
//   } else if(!validCc(phCc)){
//     markErr(tfCcIn,'Enter a valid country code e.g. +1');
//   } else if(!phLen(phCc,tfPhIn.value)){
//     markErr(tfPhIn,'Must be exactly '+reqLen(phCc)+' digits');
//   }

//   /* 6. Document upload */
//   var hasDoc=[...document.querySelectorAll('#tfDocFields input[type=file]')].some(function(f){return f.files.length>0});
//   if(!hasDoc){
//     toast('Upload at least one business verification document.','error');
//     var docWrap=$i('tfDocFields');
//     if(docWrap){
//       docWrap.style.animation='none';void docWrap.offsetWidth;
//       docWrap.style.animation='tf-shake .45s ease both';
//     }
//     if(!firstErr)firstErr=document.querySelector('#tfDocFields input[type=file]');
//   }
//   var max2=2*1024*1024;
//   for(var fi of document.querySelectorAll('#tfDocFields input[type=file]')){
//     if(fi.files.length&&fi.files[0].size>max2){
//       toast('Each document must be under 2 MB.','error');
//       if(!firstErr)firstErr=fi;
//     }
//   }

//   /* ── Errors present → scroll and stop ── */
//   if(firstErr){
//     setTimeout(function(){
//       firstErr.scrollIntoView({behavior:'smooth',block:'center'});
//       if(typeof firstErr.focus==='function')firstErr.focus({preventScroll:true});
//     },60);
//     return;
//   }

//   /* ── All valid → submit — clear draft on success ── */
//   tfSubmitting=true;
//   var sb=tfForm.querySelector('button[type=submit]');
//   sb.disabled=true;sb.textContent='Submitting…';
//   show(tfLoad);window.scrollTo({top:0,behavior:'smooth'});

//   try{
//     var r=await fetch(tfForm.action,{method:'POST',body:new FormData(tfForm)});
//     if(r.ok){
//       tfClearDraft();
//       tfForm.reset();
//       window.location.href='https://www.affirmadistributors.us/pages/thank-you';
//     }
//     else throw new Error('err');
//   }catch(err){
//     hide(tfLoad);
//     toast('Submission failed. Please check your connection and try again.','error');
//   }finally{
//     sb.disabled=false;sb.textContent='SUBMIT APPLICATION';tfSubmitting=false;
//   }
// });

// /* ── Success popup close ── */
// var tfCS=$i('tfCloseSucc');
// if(tfCS)tfCS.addEventListener('click',function(){hide(tfSucc)});

// }); /* end requestIdleCallback */


/* ── 1. Set date immediately ── */
(function(){
  var d=new Date(),p=function(n){return('0'+n).slice(-2)};
  var el=document.getElementById('tfDate');
  if(el) el.value=p(d.getDate())+'/'+p(d.getMonth()+1)+'/'+d.getFullYear();
})();

/* ── 2. Country data ── */
var TF_C=[
  {n:"Afghanistan",c:"AF",d:"+93"},{n:"Albania",c:"AL",d:"+355"},
  {n:"Algeria",c:"DZ",d:"+213"},{n:"Andorra",c:"AD",d:"+376"},
  {n:"Angola",c:"AO",d:"+244"},{n:"Antigua and Barbuda",c:"AG",d:"+1-268"},
  {n:"Argentina",c:"AR",d:"+54"},{n:"Armenia",c:"AM",d:"+374"},
  {n:"Australia",c:"AU",d:"+61"},{n:"Austria",c:"AT",d:"+43"},
  {n:"Azerbaijan",c:"AZ",d:"+994"},{n:"Bahamas",c:"BS",d:"+1-242"},
  {n:"Bahrain",c:"BH",d:"+973"},{n:"Bangladesh",c:"BD",d:"+880"},
  {n:"Barbados",c:"BB",d:"+1-246"},{n:"Belarus",c:"BY",d:"+375"},
  {n:"Belgium",c:"BE",d:"+32"},{n:"Belize",c:"BZ",d:"+501"},
  {n:"Benin",c:"BJ",d:"+229"},{n:"Bhutan",c:"BT",d:"+975"},
  {n:"Bolivia",c:"BO",d:"+591"},{n:"Bosnia and Herzegovina",c:"BA",d:"+387"},
  {n:"Botswana",c:"BW",d:"+267"},{n:"Brazil",c:"BR",d:"+55"},
  {n:"Brunei",c:"BN",d:"+673"},{n:"Bulgaria",c:"BG",d:"+359"},
  {n:"Burkina Faso",c:"BF",d:"+226"},{n:"Burundi",c:"BI",d:"+257"},
  {n:"Cabo Verde",c:"CV",d:"+238"},{n:"Cambodia",c:"KH",d:"+855"},
  {n:"Cameroon",c:"CM",d:"+237"},{n:"Canada",c:"CA",d:"+1"},
  {n:"Central African Republic",c:"CF",d:"+236"},{n:"Chad",c:"TD",d:"+235"},
  {n:"Chile",c:"CL",d:"+56"},{n:"China",c:"CN",d:"+86"},
  {n:"Colombia",c:"CO",d:"+57"},{n:"Comoros",c:"KM",d:"+269"},
  {n:"Congo (Brazzaville)",c:"CG",d:"+242"},{n:"Costa Rica",c:"CR",d:"+506"},
  {n:"Croatia",c:"HR",d:"+385"},{n:"Cuba",c:"CU",d:"+53"},
  {n:"Cyprus",c:"CY",d:"+357"},{n:"Czech Republic",c:"CZ",d:"+420"},
  {n:"Dem. Rep. Congo",c:"CD",d:"+243"},{n:"Denmark",c:"DK",d:"+45"},
  {n:"Djibouti",c:"DJ",d:"+253"},{n:"Dominica",c:"DM",d:"+1-767"},
  {n:"Dominican Republic",c:"DO",d:"+1-809"},{n:"Ecuador",c:"EC",d:"+593"},
  {n:"Egypt",c:"EG",d:"+20"},{n:"El Salvador",c:"SV",d:"+503"},
  {n:"Equatorial Guinea",c:"GQ",d:"+240"},{n:"Eritrea",c:"ER",d:"+291"},
  {n:"Estonia",c:"EE",d:"+372"},{n:"Eswatini",c:"SZ",d:"+268"},
  {n:"Ethiopia",c:"ET",d:"+251"},{n:"Fiji",c:"FJ",d:"+679"},
  {n:"Finland",c:"FI",d:"+358"},{n:"France",c:"FR",d:"+33"},
  {n:"Gabon",c:"GA",d:"+241"},{n:"Gambia",c:"GM",d:"+220"},
  {n:"Georgia",c:"GE",d:"+995"},{n:"Germany",c:"DE",d:"+49"},
  {n:"Ghana",c:"GH",d:"+233"},{n:"Greece",c:"GR",d:"+30"},
  {n:"Grenada",c:"GD",d:"+1-473"},{n:"Guatemala",c:"GT",d:"+502"},
  {n:"Guinea",c:"GN",d:"+224"},{n:"Guinea-Bissau",c:"GW",d:"+245"},
  {n:"Guyana",c:"GY",d:"+592"},{n:"Haiti",c:"HT",d:"+509"},
  {n:"Honduras",c:"HN",d:"+504"},{n:"Hungary",c:"HU",d:"+36"},
  {n:"Iceland",c:"IS",d:"+354"},{n:"India",c:"IN",d:"+91"},
  {n:"Indonesia",c:"ID",d:"+62"},{n:"Iran",c:"IR",d:"+98"},
  {n:"Iraq",c:"IQ",d:"+964"},{n:"Ireland",c:"IE",d:"+353"},
  {n:"Italy",c:"IT",d:"+39"},{n:"Jamaica",c:"JM",d:"+1-876"},
  {n:"Japan",c:"JP",d:"+81"},{n:"Jordan",c:"JO",d:"+962"},
  {n:"Kazakhstan",c:"KZ",d:"+7"},{n:"Kenya",c:"KE",d:"+254"},
  {n:"Kiribati",c:"KI",d:"+686"},{n:"Kuwait",c:"KW",d:"+965"},
  {n:"Kyrgyzstan",c:"KG",d:"+996"},{n:"Laos",c:"LA",d:"+856"},
  {n:"Latvia",c:"LV",d:"+371"},{n:"Lebanon",c:"LB",d:"+961"},
  {n:"Lesotho",c:"LS",d:"+266"},{n:"Liberia",c:"LR",d:"+231"},
  {n:"Libya",c:"LY",d:"+218"},{n:"Liechtenstein",c:"LI",d:"+423"},
  {n:"Lithuania",c:"LT",d:"+370"},{n:"Luxembourg",c:"LU",d:"+352"},
  {n:"Madagascar",c:"MG",d:"+261"},{n:"Malawi",c:"MW",d:"+265"},
  {n:"Malaysia",c:"MY",d:"+60"},{n:"Maldives",c:"MV",d:"+960"},
  {n:"Mali",c:"ML",d:"+223"},{n:"Malta",c:"MT",d:"+356"},
  {n:"Marshall Islands",c:"MH",d:"+692"},{n:"Mauritania",c:"MR",d:"+222"},
  {n:"Mauritius",c:"MU",d:"+230"},{n:"Mexico",c:"MX",d:"+52"},
  {n:"Micronesia",c:"FM",d:"+691"},{n:"Moldova",c:"MD",d:"+373"},
  {n:"Monaco",c:"MC",d:"+377"},{n:"Mongolia",c:"MN",d:"+976"},
  {n:"Montenegro",c:"ME",d:"+382"},{n:"Morocco",c:"MA",d:"+212"},
  {n:"Mozambique",c:"MZ",d:"+258"},{n:"Myanmar",c:"MM",d:"+95"},
  {n:"Namibia",c:"NA",d:"+264"},{n:"Nauru",c:"NR",d:"+674"},
  {n:"Nepal",c:"NP",d:"+977"},{n:"Netherlands",c:"NL",d:"+31"},
  {n:"New Zealand",c:"NZ",d:"+64"},{n:"Nicaragua",c:"NI",d:"+505"},
  {n:"Niger",c:"NE",d:"+227"},{n:"Nigeria",c:"NG",d:"+234"},
  {n:"North Korea",c:"KP",d:"+850"},{n:"North Macedonia",c:"MK",d:"+389"},
  {n:"Norway",c:"NO",d:"+47"},{n:"Oman",c:"OM",d:"+968"},
  {n:"Pakistan",c:"PK",d:"+92"},{n:"Palau",c:"PW",d:"+680"},
  {n:"Panama",c:"PA",d:"+507"},{n:"Papua New Guinea",c:"PG",d:"+675"},
  {n:"Paraguay",c:"PY",d:"+595"},{n:"Peru",c:"PE",d:"+51"},
  {n:"Philippines",c:"PH",d:"+63"},{n:"Poland",c:"PL",d:"+48"},
  {n:"Portugal",c:"PT",d:"+351"},{n:"Qatar",c:"QA",d:"+974"},
  {n:"Romania",c:"RO",d:"+40"},{n:"Russia",c:"RU",d:"+7"},
  {n:"Rwanda",c:"RW",d:"+250"},{n:"Saint Kitts and Nevis",c:"KN",d:"+1-869"},
  {n:"Saint Lucia",c:"LC",d:"+1-758"},{n:"Saint Vincent",c:"VC",d:"+1-784"},
  {n:"Samoa",c:"WS",d:"+685"},{n:"San Marino",c:"SM",d:"+378"},
  {n:"Saudi Arabia",c:"SA",d:"+966"},{n:"Senegal",c:"SN",d:"+221"},
  {n:"Serbia",c:"RS",d:"+381"},{n:"Seychelles",c:"SC",d:"+248"},
  {n:"Sierra Leone",c:"SL",d:"+232"},{n:"Singapore",c:"SG",d:"+65"},
  {n:"Slovakia",c:"SK",d:"+421"},{n:"Slovenia",c:"SI",d:"+386"},
  {n:"Solomon Islands",c:"SB",d:"+677"},{n:"Somalia",c:"SO",d:"+252"},
  {n:"South Africa",c:"ZA",d:"+27"},{n:"South Korea",c:"KR",d:"+82"},
  {n:"South Sudan",c:"SS",d:"+211"},{n:"Spain",c:"ES",d:"+34"},
  {n:"Sri Lanka",c:"LK",d:"+94"},{n:"Sudan",c:"SD",d:"+249"},
  {n:"Suriname",c:"SR",d:"+597"},{n:"Sweden",c:"SE",d:"+46"},
  {n:"Switzerland",c:"CH",d:"+41"},{n:"Syria",c:"SY",d:"+963"},
  {n:"Taiwan",c:"TW",d:"+886"},{n:"Tajikistan",c:"TJ",d:"+992"},
  {n:"Tanzania",c:"TZ",d:"+255"},{n:"Thailand",c:"TH",d:"+66"},
  {n:"Timor-Leste",c:"TL",d:"+670"},{n:"Togo",c:"TG",d:"+228"},
  {n:"Tonga",c:"TO",d:"+676"},{n:"Trinidad and Tobago",c:"TT",d:"+1-868"},
  {n:"Tunisia",c:"TN",d:"+216"},{n:"Turkey",c:"TR",d:"+90"},
  {n:"Turkmenistan",c:"TM",d:"+993"},{n:"Tuvalu",c:"TV",d:"+688"},
  {n:"Uganda",c:"UG",d:"+256"},{n:"Ukraine",c:"UA",d:"+380"},
  {n:"United Arab Emirates",c:"AE",d:"+971"},{n:"United Kingdom",c:"GB",d:"+44"},
  {n:"United States",c:"US",d:"+1"},{n:"Uruguay",c:"UY",d:"+598"},
  {n:"Uzbekistan",c:"UZ",d:"+998"},{n:"Vanuatu",c:"VU",d:"+678"},
  {n:"Vatican City",c:"VA",d:"+379"},{n:"Venezuela",c:"VE",d:"+58"},
  {n:"Vietnam",c:"VN",d:"+84"},{n:"Yemen",c:"YE",d:"+967"},
  {n:"Zambia",c:"ZM",d:"+260"},{n:"Zimbabwe",c:"ZW",d:"+263"}
];

/* ── 3. Phone length map ── */
var TF_PL={
  "+1":10,"+44":10,"+93":9,"+355":9,"+213":9,"+376":8,"+244":9,"+54":10,
  "+374":8,"+61":9,"+43":10,"+994":9,"+973":8,"+880":10,"+375":9,"+32":9,
  "+501":8,"+229":8,"+975":8,"+591":8,"+387":8,"+267":8,"+55":11,"+673":7,
  "+359":9,"+226":8,"+257":8,"+238":7,"+855":9,"+237":9,"+506":8,"+385":9,
  "+53":8,"+357":8,"+420":9,"+243":9,"+45":8,"+253":7,"+593":9,"+20":10,
  "+503":8,"+240":7,"+291":7,"+372":8,"+251":9,"+679":7,"+358":9,"+33":9,
  "+241":8,"+220":7,"+995":9,"+49":11,"+233":10,"+30":10,"+502":8,"+224":8,
  "+245":7,"+592":7,"+509":8,"+504":8,"+36":9,"+354":7,"+91":10,"+62":11,
  "+98":10,"+964":10,"+353":9,"+39":10,"+81":10,"+962":9,"+7":10,"+254":10,
  "+686":5,"+965":8,"+996":9,"+856":9,"+371":8,"+961":8,"+266":8,"+231":8,
  "+218":9,"+423":7,"+370":8,"+352":9,"+261":9,"+265":9,"+60":10,"+960":7,
  "+223":8,"+356":8,"+692":5,"+222":7,"+230":7,"+52":10,"+691":5,"+373":8,
  "+377":8,"+976":8,"+382":8,"+212":9,"+258":9,"+95":9,"+264":9,"+674":5,
  "+977":10,"+31":9,"+64":9,"+505":8,"+227":8,"+234":10,"+850":9,"+389":8,
  "+47":8,"+968":8,"+92":10,"+680":5,"+507":8,"+675":7,"+595":9,"+51":9,
  "+63":10,"+48":9,"+351":9,"+974":8,"+40":9,"+250":9,"+966":9,"+221":9,
  "+381":9,"+248":7,"+232":8,"+65":8,"+421":9,"+386":9,"+677":5,"+252":8,
  "+27":9,"+82":10,"+211":9,"+34":9,"+94":10,"+249":9,"+597":7,"+46":9,
  "+41":9,"+963":9,"+886":9,"+992":9,"+255":10,"+66":9,"+670":5,"+228":8,
  "+676":5,"+216":8,"+90":10,"+993":8,"+688":5,"+256":9,"+380":9,"+971":8,
  "+598":8,"+998":9,"+678":5,"+379":8,"+58":10,"+84":9,"+967":9,"+260":9,"+263":9
};

/* ── 4. Validation helpers ── */
var _tfOrigPlaceholders = new WeakMap();

function fieldError(input, message) {
  if (!input) return;
  if (!_tfOrigPlaceholders.has(input)) {
    _tfOrigPlaceholders.set(input, input.placeholder || '');
  }
  input.placeholder = '⚠ ' + message;
  input.value = '';
  input.classList.add('tf-input-error');
  var wrap = input.closest('div') || input.parentElement;
  if (wrap) {
    wrap.classList.remove('tf-field-error');
    void wrap.offsetWidth;
    wrap.classList.add('tf-field-error');
  }
  function onInput() {
    fieldClear(input);
    input.removeEventListener('input', onInput);
    input.removeEventListener('change', onInput);
  }
  input.addEventListener('input', onInput);
  input.addEventListener('change', onInput);
}

function fieldClear(input) {
  if (!input) return;
  input.classList.remove('tf-input-error');
  if (_tfOrigPlaceholders.has(input)) {
    input.placeholder = _tfOrigPlaceholders.get(input);
  }
  var wrap = input.closest('div') || input.parentElement;
  if (wrap) {
    wrap.classList.remove('tf-field-error');
    wrap.classList.add('tf-field-clearing');
    setTimeout(function(){ wrap.classList.remove('tf-field-clearing'); }, 400);
  }
}

function scrollToFirst() {
  setTimeout(function(){
    var first = document.querySelector('.tf-field-error input, .tf-input-error');
    if (first) {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      first.focus({ preventScroll: true });
    }
  }, 60);
}

/* ════════════════════════════════════════════
   ── DRAFT PERSISTENCE (localStorage) ──
   Saves every field on input/change.
   Restores on page load. Cleared on success.
   ════════════════════════════════════════════ */
var TF_DRAFT_KEY = 'tf_draft_v1';

function tfSaveDraft() {
  try {
    var form = document.getElementById('tfForm');
    if (!form) return;
    var draft = {};
    form.querySelectorAll(
      'input:not([type=file]):not([type=submit]):not([type=button]), textarea'
    ).forEach(function(el) {
      var key = el.name || el.id;
      if (!key) return;
      if (el.type === 'checkbox') {
        draft[key] = el.checked;
      } else if (el.type === 'radio') {
        if (el.checked) draft[key] = el.value;
      } else {
        draft[key] = el.value;
      }
    });
    localStorage.setItem(TF_DRAFT_KEY, JSON.stringify(draft));
  } catch(e) {}
}

function tfRestoreDraft() {
  try {
    var raw = localStorage.getItem(TF_DRAFT_KEY);
    if (!raw) return;
    var draft = JSON.parse(raw);
    var form = document.getElementById('tfForm');
    if (!form) return;

    form.querySelectorAll(
      'input:not([type=file]):not([type=submit]):not([type=button]), textarea'
    ).forEach(function(el) {
      var key = el.name || el.id;
      if (!key || !(key in draft)) return;
      if (el.id === 'tfDate') return; /* always regenerated fresh */
      if (el.type === 'checkbox') {
        el.checked = !!draft[key];
      } else if (el.type === 'radio') {
        if (el.value === draft[key]) el.checked = true;
      } else {
        el.value = draft[key];
      }
    });

    /* Re-sync country hidden field */
    var cntryHidden = document.getElementById('tfCntryHidden');
    if (cntryHidden && draft['country']) {
      cntryHidden.value = draft['country'];
    }

  } catch(e) {}
}

function tfClearDraft() {
  try { localStorage.removeItem(TF_DRAFT_KEY); } catch(e) {}
}

/* ── 5. Defer all interactive JS ── */
(window.requestIdleCallback||function(cb){setTimeout(cb,100)})(function(){

var tfEmailOk=false,tfSubmitting=false,tfCooldown=false,tfTimer=null;
var tfDeclAccepted=false;
var SEND_OTP='https://hook.us2.make.com/oy8cimjhhfeh4rhifgsx2h7uhk39z3ej';
var VERIFY_OTP='https://hook.us2.make.com/jyx8okv6i6sf8sf2furos1gyld7ycu8a';

function $i(id){return document.getElementById(id)}
var tfForm=$i('tfForm'),tfEmail=$i('tfEmail'),tfSendOtp=$i('tfSendOtp'),
    tfVerOtp=$i('tfVerifyOtp'),tfOtpBox=$i('tfOtpBox'),tfOtpIn=$i('tfOtpInput'),
    tfStat=$i('tfOtpStatus'),tfCcIn=$i('tfCcInput'),tfCcLst=$i('tfCcList'),
    tfPhIn=$i('tfPhone'),
    tfCIn=$i('tfCntryInput'),tfCHid=$i('tfCntryHidden'),
    tfCLst=$i('tfCntryList'),tfCTip=$i('tfCntryTip'),
    tfLoad=$i('tfLoadPop'),tfSucc=$i('tfSuccPop'),
    tfDeclChk=$i('tfDeclChk'),
    tfDeclHidden=$i('tfDeclHidden');

/* ── Restore saved draft ── */
tfRestoreDraft();

/* Re-sync declarations flag if checkbox was restored as checked */
if (tfDeclChk && tfDeclChk.checked) {
  tfDeclAccepted = true;
  if (tfDeclHidden) tfDeclHidden.value = 'I accept all declarations and compliance terms';
}

/* ── Sync default country into hidden field ── */
if (tfCIn && tfCHid && !tfCHid.value && tfCIn.value) {
  tfCHid.value = tfCIn.value.trim();
}

/* ── Auto-save on any input/change ── */
tfForm.addEventListener('input', tfSaveDraft, {passive: true});
tfForm.addEventListener('change', tfSaveDraft, {passive: true});

function show(el){el&&el.classList.remove('tf-hidden')}
function hide(el){el&&el.classList.add('tf-hidden')}
function stat(m){if(tfStat)tfStat.textContent=m}

/* ── Toast ── */
var tfToastEl=$i('tfToast'),tfToastTimer=null;
function toast(msg,type){
  if(!tfToastEl)return;
  tfToastEl.textContent=msg;
  tfToastEl.className=(type==='error'?'tf-toast--error':type==='warn'?'tf-toast--warn':'');
  tfToastEl.classList.add('show');
  clearTimeout(tfToastTimer);
  tfToastTimer=setTimeout(function(){tfToastEl.classList.remove('show')},4000);
}

function validCc(v){
  var t=v.trim();
  return TF_C.some(function(c){return c.d===t});
}
function phLen(cc,num){
  var r=TF_PL[cc.trim()];
  return r?num.replace(/\D/g,'').length===r:false;
}
function reqLen(cc){return TF_PL[cc.trim()]||'?'}

function renderList(ul,items,q,dial,onSel){
  var lq=q.toLowerCase();
  var filtered=items.filter(function(it){
    return it.n.toLowerCase().includes(lq)||(dial&&it.d.includes(lq));
  }).slice(0,60);
  var frag=document.createDocumentFragment();
  filtered.forEach(function(it,i){
    var li=document.createElement('li');
    li.setAttribute('role','option');
    li.innerHTML='<img src="https://flagcdn.com/24x18/'+it.c.toLowerCase()+'.png" width="24" height="18" loading="lazy" alt="'+it.n+'" onerror="this.style.display=\'none\'">'
      +'<span>'+(dial?it.d+' ('+it.n+')':it.n)+'</span>';
    li._d=it;
    if(i===0)li.classList.add('tf-sel');
    li.addEventListener('click',function(){onSel(it)});
    frag.appendChild(li);
  });
  ul.innerHTML='';ul.appendChild(frag);
  ul.style.display=filtered.length?'block':'none';
}

function navList(ul,e){
  var items=ul.querySelectorAll('li');if(!items.length)return;
  var cur=Array.from(items).findIndex(function(li){return li.classList.contains('tf-sel')});
  function mv(next){
    if(cur>=0)items[cur].classList.remove('tf-sel');
    items[next].classList.add('tf-sel');
    items[next].scrollIntoView({block:'nearest'});
  }
  if(e.key==='ArrowDown'){e.preventDefault();mv((cur+1)%items.length)}
  else if(e.key==='ArrowUp'){e.preventDefault();mv((cur-1+items.length)%items.length)}
  else if(e.key==='Enter'){e.preventDefault();var s=ul.querySelector('li.tf-sel');if(s)s.click()}
  else if(e.key==='Escape')ul.style.display='none';
}

/* ── Country autocomplete ── */
var tfCFocusLock=false;
function selCntry(it){
  tfCIn.value=it.n;
  tfCHid.value=it.n;
  tfCLst.style.display='none';
  tfCTip.classList.remove('show');
  tfCIn.style.borderColor='#16a34a';
  setTimeout(function(){tfCIn.style.borderColor=''},1000);
  fieldClear(tfCIn);
  tfCFocusLock=true;tfCIn.focus();setTimeout(function(){tfCFocusLock=false},100);
}
tfCIn.addEventListener('focus',function(){
  if(tfCFocusLock){tfCFocusLock=false;return}
  renderList(tfCLst,TF_C,tfCIn.value,false,selCntry);
  tfCTip.classList.add('show');
});
tfCIn.addEventListener('input',function(){
  tfCHid.value = this.value.trim();
  renderList(tfCLst,TF_C,this.value,false,selCntry);
});
tfCIn.addEventListener('keydown',function(e){navList(tfCLst,e)});

/* ── Phone CC ── */
var tfPhFocusLock=false;
function selCc(it){
  tfCcIn.value=it.d;
  tfCcLst.style.display='none';
  fieldClear(tfCcIn);
  tfPhFocusLock=true;tfPhIn.focus();setTimeout(function(){tfPhFocusLock=false},100);
}
tfCcIn.addEventListener('focus',function(){
  if(tfPhFocusLock||tfCcIn.readOnly){tfPhFocusLock=false;return}
  renderList(tfCcLst,TF_C,tfCcIn.value,true,selCc);
});
tfCcIn.addEventListener('input',function(){
  if(tfCcIn.readOnly)return;
  renderList(tfCcLst,TF_C,this.value,true,selCc);
});
tfCcIn.addEventListener('keydown',function(e){if(!tfCcIn.readOnly)navList(tfCcLst,e)});
tfPhIn.addEventListener('input',function(){
  var cc=tfCcIn.value.trim();
  if(cc&&phLen(cc,this.value)) fieldClear(tfPhIn);
},{passive:true});

/* ── Close dropdowns on outside click ── */
document.addEventListener('click',function(e){
  if(!e.target.closest('#tfCcWrap'))tfCcLst.style.display='none';
  if(!e.target.closest('#tfCntryWrap')){
    tfCLst.style.display='none';
    tfCTip.classList.remove('show');
  }
},{passive:true});

/* ── OTP cooldown — 3 minutes ── */
function startCooldown(){
  tfCooldown=true;var t=300;
  tfSendOtp.disabled=true;tfSendOtp.style.background='#9ca3af';
  tfTimer=setInterval(function(){
    if(--t<=0){
      clearInterval(tfTimer);tfCooldown=false;
      tfSendOtp.disabled=false;tfSendOtp.style.background='#1f7ca1';
      tfSendOtp.textContent='Resend OTP';
    } else {
      var mins=Math.floor(t/60);
      var secs=t%60;
      tfSendOtp.textContent='Resend OTP ('+mins+':'+(secs<10?'0':'')+secs+')';
    }
  },1000);
}

/* ── Send OTP ── */
tfSendOtp.addEventListener('click',async function(){
  var em=tfEmail.value.trim();
  var cc=tfCcIn.value.trim();
  var ph=tfPhIn.value.trim();
  var hasErr=false;

  if(!em||!em.includes('@')){
    fieldError(tfEmail,'Enter a valid email address');
    hasErr=true;
  }
  if(!cc){
    fieldError(tfCcIn,'Enter a country code e.g. +1');
    hasErr=true;
  } else if(!validCc(cc)){
    fieldError(tfCcIn,'Enter a valid country code e.g. +1');
    hasErr=true;
  }
  if(!ph){
    fieldError(tfPhIn,'Enter phone number');
    hasErr=true;
  } else if(cc&&validCc(cc)&&!phLen(cc,ph)){
    fieldError(tfPhIn,'Must be exactly '+reqLen(cc)+' digits');
    hasErr=true;
  }
  if(hasErr){scrollToFirst();return;}

  var otp=Math.floor(100000+Math.random()*900000);
  window._tfOtp=otp;stat('Sending OTP…');tfSendOtp.disabled=true;
  try{
    await fetch(SEND_OTP+'?email='+encodeURIComponent(em)+'&otp='+otp);
    show(tfOtpBox);show(tfVerOtp);stat('OTP sent to your email');
    tfSendOtp.textContent='Resend OTP';startCooldown();
  }catch(e){
    stat('Failed to send OTP. Please try again.');
    tfSendOtp.disabled=false;tfSendOtp.style.background='#1f7ca1';
  }
});

/* ── Verify OTP ── */
tfVerOtp.addEventListener('click',async function(){
  var u=tfOtpIn.value.trim();
  if(!u){fieldError(tfOtpIn,'Enter the 6-digit OTP');scrollToFirst();return;}
  stat('Verifying…');tfVerOtp.disabled=true;
  try{
    var res=await fetch(VERIFY_OTP+'?email='+encodeURIComponent(tfEmail.value.trim())+'&otp='+u);
    var data=await res.json();
    if(data.status==='verified'){
      tfEmailOk=true;stat('✓ Email and phone verified');
      [tfEmail,tfCcIn,tfPhIn].forEach(function(el){
        el.readOnly=true;el.style.background='#f3f4f6';
      });
      tfCcIn.style.cursor='not-allowed';tfCcLst.style.display='none';
      hide(tfSendOtp);hide(tfOtpBox);hide(tfVerOtp);
    } else {
      fieldError(tfOtpIn,'Invalid OTP — try again');
      scrollToFirst();
    }
  }catch(e){stat('Verification failed. Please try again.')}
  finally{tfVerOtp.disabled=false}
});

/* ── Declarations checkbox ── */
if(tfDeclChk){
  tfDeclChk.addEventListener('change',function(){
    tfDeclAccepted=this.checked;
    tfDeclHidden.value=this.checked?'I accept all declarations and compliance terms':'';
  });
}

/* ── Document management ── */
var tfDocN=1;var TF_MAX=4;
window.tfAddDoc=function(){
  if(tfDocN>=TF_MAX)return;
  tfDocN++;
  var wrap=$i('tfDocFields'),div=document.createElement('div');
  div.className='tf__doc-row';div.dataset.index=tfDocN;
  div.innerHTML='<input type="file" name="document'+tfDocN+'" accept=".pdf,.jpg,.png">'
    +'<button type="button" class="tf__doc-btn tf__doc-btn--rem" onclick="tfRemDoc(this)">−</button>';
  wrap.appendChild(div);
  var ab=$i('tfAddDocBtn');if(ab)ab.disabled=(tfDocN>=TF_MAX);
};
window.tfRemDoc=function(btn){
  var f=btn.closest('.tf__doc-row');
  if(f){f.remove();tfDocN--;var ab=$i('tfAddDocBtn');if(ab)ab.disabled=(tfDocN>=TF_MAX);}
};

/* ════════════════════════════════════════════
   ── FORM SUBMIT ──
   ════════════════════════════════════════════ */
tfForm.addEventListener('submit',async function(e){
  e.preventDefault();
  if(tfSubmitting)return;

  var firstErr=null;
  function markErr(input,msg){
    fieldError(input,msg);
    if(!firstErr)firstErr=input;
  }

  /* 1. Declarations */
  if(!tfDeclAccepted){
    var declWrap=tfDeclChk?tfDeclChk.closest('.tf__fs'):null;
    if(declWrap){
      declWrap.style.border='2px solid #ef4444';
      declWrap.style.animation='none';
      void declWrap.offsetWidth;
      declWrap.style.animation='tf-shake .45s ease both';
      tfDeclChk.addEventListener('change',function(){
        declWrap.style.border='';declWrap.style.animation='';
      },{once:true});
    }
    if(!firstErr)firstErr=tfDeclChk;
    toast('Please accept the Declarations & Compliance to proceed.','error');
  }

  /* 2. Email + OTP verification */
  if(!tfEmailOk){
    markErr(tfEmail,'Verify your email first — click Send OTP');
  }

  /* 3. Country */
  var countryVal=(tfCHid.value||'').trim()||(tfCIn.value||'').trim();
  if(!countryVal){
    markErr(tfCIn,'Enter your country of registration');
  } else {
    tfCHid.value=countryVal;
    tfCIn.value=countryVal;
  }

  /* 4. Required text/number inputs */
  var reqInputs=tfForm.querySelectorAll(
    'input[required]:not([type=radio]):not([type=checkbox]):not([type=file]):not(#tfEmail):not(#tfPhone):not(#tfCntryHidden):not(#tfCntryInput):not(#tfCcInput)'
  );
  reqInputs.forEach(function(inp){
    if(!inp.value.trim()){
      var fs=inp.closest('fieldset')||inp.parentElement;
      var labelEl=fs?fs.querySelector('label'):null;
      var name=labelEl?labelEl.textContent.replace('*','').trim():'This field';
      markErr(inp,name+' is required');
    }
  });

  /* 5. Phone CC + length */
  var phCc=tfCcIn.value.trim();
  if(!phCc){
    markErr(tfCcIn,'Enter a country code e.g. +1');
  } else if(!validCc(phCc)){
    markErr(tfCcIn,'Enter a valid country code e.g. +1');
  } else if(!phLen(phCc,tfPhIn.value)){
    markErr(tfPhIn,'Must be exactly '+reqLen(phCc)+' digits');
  }

  /* 6. Document upload */
  var hasDoc=[...document.querySelectorAll('#tfDocFields input[type=file]')].some(function(f){return f.files.length>0});
  if(!hasDoc){
    toast('Upload at least one business verification document.','error');
    var docWrap=$i('tfDocFields');
    if(docWrap){
      docWrap.style.animation='none';void docWrap.offsetWidth;
      docWrap.style.animation='tf-shake .45s ease both';
    }
    if(!firstErr)firstErr=document.querySelector('#tfDocFields input[type=file]');
  }
  var max2=2*1024*1024;
  for(var fi of document.querySelectorAll('#tfDocFields input[type=file]')){
    if(fi.files.length&&fi.files[0].size>max2){
      toast('Each document must be under 2 MB.','error');
      if(!firstErr)firstErr=fi;
    }
  }

  /* ── Errors present → scroll and stop ── */
  if(firstErr){
    setTimeout(function(){
      firstErr.scrollIntoView({behavior:'smooth',block:'center'});
      if(typeof firstErr.focus==='function')firstErr.focus({preventScroll:true});
    },60);
    return;
  }

  /* ── All valid → submit — clear draft on success ── */
  tfSubmitting=true;
  var sb=tfForm.querySelector('button[type=submit]');
  sb.disabled=true;sb.textContent='Submitting…';
  show(tfLoad);window.scrollTo({top:0,behavior:'smooth'});

  try{
    var r=await fetch(tfForm.action,{method:'POST',body:new FormData(tfForm)});
    if(r.ok){
      tfClearDraft();
      tfForm.reset();
      window.location.href='https://www.affirmadistributors.us/pages/thank-you';
    }
    else throw new Error('err');
  }catch(err){
    hide(tfLoad);
    toast('Submission failed. Please check your connection and try again.','error');
  }finally{
    sb.disabled=false;sb.textContent='SUBMIT APPLICATION';tfSubmitting=false;
  }
});

/* ── Success popup close ── */
var tfCS=$i('tfCloseSucc');
if(tfCS)tfCS.addEventListener('click',function(){hide(tfSucc)});

}); /* end requestIdleCallback */

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ws-cta-left-video__player").forEach(video => {
    video.muted = true;
    video.play().catch(() => {});
  });
});

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.shopify-section').forEach(function (sectionElement) {
      if (!sectionElement.querySelector('.ws-how-it-works, .ws-product-ad-card, .ws-product-display-card, .ws-faqs, .ws-simple-final-cta')) return;

      const sectionId = sectionElement.id.replace('shopify-section-', '');
      const wsStartTime = performance.now();

      class wsStepLayout {
        constructor(container) {
          this.stepsContainer = container;
          if (!this.stepsContainer) return;
          this.wsInit();
        }

        wsInit() {
          this.wsCountSteps();
          this.wsAddLayoutClass();
          window.addEventListener('resize', this.wsDebounce(() => {
            this.wsUpdateLayout();
          }, 250));
          this.wsAnimateSteps();
        }

        wsCountSteps() {
          const steps = this.stepsContainer.querySelectorAll('.ws-step');
          this.stepCount = steps.length;
          return this.stepCount;
        }

        wsAddLayoutClass() {
          this.stepsContainer.classList.remove('ws-steps-1', 'ws-steps-2', 'ws-steps-3', 'ws-steps-4', 'ws-steps-5');
          if (this.stepCount > 0) this.stepsContainer.classList.add(`ws-steps-${this.stepCount}`);
          this.wsUpdateConnectingLine();
        }

        wsUpdateConnectingLine() {
          const line = this.stepsContainer.querySelector('.ws-step-connector-line');
          if (this.stepCount === 5 && window.innerWidth >= 992) {
            if (!line) this.wsCreateConnectingLine();
          } else if (line) {
            line.remove();
          }
        }

        wsCreateConnectingLine() {
          const line = document.createElement('div');
          line.className = 'ws-step-connector-line';
          line.style.cssText = `
            position: absolute;
            top: 60px;
            left: 10%;
            right: 10%;
            height: 2px;
            background: linear-gradient(
              90deg,
              transparent 0%,
              var(--ws-color-secondary) 20%,
              var(--ws-color-secondary) 80%,
              transparent 100%
            );
            opacity: 0.15;
            z-index: 1;
          `;
          this.stepsContainer.insertBefore(line, this.stepsContainer.firstChild);
        }

        wsAnimateSteps() {
          const steps = this.stepsContainer.querySelectorAll('.ws-step');
          steps.forEach((step, index) => {
            setTimeout(() => {
              step.style.opacity = '1';
              step.style.transform = 'translateY(0)';
            }, index * 150);
          });
        }

        wsUpdateLayout() {
          this.wsUpdateConnectingLine();
        }

        wsDebounce(func, wait) {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
          };
        }
      }

      class wsAnimationController {
        constructor(sectionElement) {
          this.sectionElement = sectionElement;
          this.wsAnimatedElements = new Set();
          this.wsObserver = null;
          this.wsInit();
        }

        wsInit() {
          if (!('IntersectionObserver' in window)) {
            this.wsAnimateAll();
            return;
          }

          this.wsObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.wsAnimateElement(entry.target);
                this.wsObserver.unobserve(entry.target);
              }
            });
          }, {
            root: null,
            rootMargin: '100px',
            threshold: 0.1,
          });

          this.wsSetupObservers();
        }

        wsSetupObservers() {
          const elements = this.sectionElement.querySelectorAll(
            '[data-ws-delay], .ws-step, .ws-product-ad-card, .ws-product-display-card, .ws-faq-item, .ws-stats-card, .ws-simple-final-cta__box'
          );
          elements.forEach((element) => this.wsObserver.observe(element));
        }

        wsAnimateElement(element) {
          const delay = element.dataset.wsDelay || 0;
          setTimeout(() => {
            element.classList.add('ws-animate-slide-up');
          }, delay * 1000);
          this.wsAnimatedElements.add(element);
        }

        wsAnimateAll() {
          const elements = this.sectionElement.querySelectorAll('.ws-step, .ws-product-ad-card, .ws-product-display-card, .ws-faq-item, .ws-stats-card, .ws-simple-final-cta__box');
          elements.forEach((element, index) => {
            setTimeout(() => {
              element.classList.add('ws-animate-slide-up');
            }, index * 100);
          });
        }
      }

      class wsCTATracker {
        constructor(sectionElement) {
          this.sectionElement = sectionElement;
          this.wsCtaButtons = sectionElement.querySelectorAll('[data-ws-cta]');
          this.wsInit();
        }

        wsInit() {
          this.wsCtaButtons.forEach((button) => {
            button.addEventListener('click', (e) => this.wsHandleCTAClick(e));
          });
        }

        wsHandleCTAClick(event) {
          const button = event.currentTarget;
          const ctaType = button.dataset.wsCta;

          button.classList.add('ws-button--clicked');
          setTimeout(() => button.classList.remove('ws-button--clicked'), 300);

          if (typeof gtag !== 'undefined') {
            gtag('event', 'click', {
              event_category: 'CTA',
              event_label: `${ctaType} - Wholesale Page`,
            });
          }
        }
      }

      sectionElement.querySelectorAll('a[href^="#ws-apply-"]').forEach((link) => {
        link.addEventListener('click', (e) => {
          const target = document.getElementById(link.getAttribute('href').slice(1));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      const stepsContainer = sectionElement.querySelector('.ws-how-it-works__steps');

      const wsModules = {
        stepLayout: stepsContainer ? new wsStepLayout(stepsContainer) : null,
        animations: new wsAnimationController(sectionElement),
        ctaTracker: new wsCTATracker(sectionElement),
      };

      sectionElement.classList.add('ws-loaded');

      sectionElement.dispatchEvent(
        new CustomEvent('ws:ready', {
          detail: { modules: wsModules },
        })
      );

      const wsInitTime = performance.now() - wsStartTime;
      if (window.location.hostname === 'localhost') {
        console.log(`Wholesale section ${sectionId} initialized in ${wsInitTime.toFixed(2)}ms`);
      }
    });
  });
})();


/* ── FAQs Stats Image Carousel ── */
(function () {
  function initWsStatsCarousel(root) {
    if (!root || root.dataset.wsStatsReady === 'true') return;
    root.dataset.wsStatsReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ws-stats-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ws-stats-dot]'));
    var prev = root.querySelector('[data-ws-stats-prev]');
    var next = root.querySelector('[data-ws-stats-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed || '3500', 10);
    var index = 0;
    var timer = null;

    if (!slides.length) return;

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (autoplay && slides.length > 1) {
        timer = setInterval(function () {
          goTo(index + 1);
        }, speed);
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1);
        start();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1);
        start();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.wsStatsDot || '0', 10));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    goTo(0);
    start();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ws-stats-carousel]').forEach(initWsStatsCarousel);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ws-stats-carousel]').forEach(initWsStatsCarousel);
  });
})();



/* ── Testimonials carousel for draggable block ── */
(function () {
  function initWsTestimonialsCarousel(carousel) {
    if (!carousel || carousel.dataset.wsTestimonialsReady === 'true') return;

    var track = carousel.querySelector('[data-ws-testimonials-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-ws-testimonial-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-ws-testimonials-dot]'));
    var prev = carousel.querySelector('[data-ws-testimonials-prev]');
    var next = carousel.querySelector('[data-ws-testimonials-next]');

    if (!track || slides.length <= 1) return;
    carousel.dataset.wsTestimonialsReady = 'true';

    function getGap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || 0) || 0;
    }

    function getCurrentIndex() {
      var width = slides[0].getBoundingClientRect().width + getGap();
      if (!width) return 0;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
    }

    function update(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      var left = slides[index].offsetLeft - track.offsetLeft;
      track.scrollTo({ left: left, behavior: 'smooth' });
      update(index);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-ws-testimonials-dot'), 10) || 0);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(getCurrentIndex() - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(getCurrentIndex() + 1);
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        update(getCurrentIndex());
      });
    }, { passive: true });

    update(0);
  }

  function initAllWsTestimonials() {
    document.querySelectorAll('[data-ws-testimonials-carousel]').forEach(initWsTestimonialsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllWsTestimonials);
  } else {
    initAllWsTestimonials();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ws-testimonials-carousel]').forEach(initWsTestimonialsCarousel);
  });
})();



/* ── Trustpilot screenshots auto carousel pause/touch helper ── */
(function () {
  function initWsTrustpilotAutoCarousel(carousel) {
    if (!carousel || carousel.dataset.wsTrustpilotAutoReady === 'true') return;
    carousel.dataset.wsTrustpilotAutoReady = 'true';

    var pause = function () { carousel.classList.add('is-paused'); };
    var resume = function () { carousel.classList.remove('is-paused'); };

    carousel.addEventListener('pointerdown', pause, { passive: true });
    carousel.addEventListener('pointerup', resume, { passive: true });
    carousel.addEventListener('pointercancel', resume, { passive: true });
    carousel.addEventListener('touchstart', pause, { passive: true });
    carousel.addEventListener('touchend', resume, { passive: true });
  }

  function initAllWsTrustpilotAuto() {
    document.querySelectorAll('[data-ws-trustpilot-auto]').forEach(initWsTrustpilotAutoCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllWsTrustpilotAuto);
  } else {
    initAllWsTrustpilotAuto();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ws-trustpilot-auto]').forEach(initWsTrustpilotAutoCarousel);
  });
})();
